import React from "react";
import logo from "../../../assets/logo.png";
import colorIcon from "../../../assets/color_icon.svg";
import artistImage from "../../../assets/artist_image.svg";
import homeImage from "../../../assets/home_image.svg";
import requestContestIcon from "../../../assets/contest_request_icon.svg";
import dollerIcon from "../../../assets/dollar_icon.svg";
import planIcon from "../../../assets/freepricing_icon.png";

import { NavLink } from "react-router-dom";
import { FiX } from "react-icons/fi";

export const AdminSidebar = ({ isOpen, setOpenMenu }) => {
  const requestedStatusCode=120;
const allStatusCode=0;

  const admin = [

     {path: "/admin", label: "Home", icon: homeImage },
     {path: `/admin/contests/${allStatusCode}`, label: "All Contests", icon: colorIcon },
     {path: `/admin/contests/${requestedStatusCode}`, label: "Contest Requests", icon: requestContestIcon },
    //  {path: '/admin/contest-results', label: "Contest Results", icon: resultContestIcon },
     {path: "/admin/artists", label: "Artists", icon: artistImage },
     {path: "/admin/subscribe-plans", label: "Subscribe Users", icon: planIcon },
     {path: "/admin/revenue", label: "Revenue", icon: dollerIcon },
     {path: "/admin/create-contest", label: "Create Contest", icon: dollerIcon },
   
  ];

  const menuItems =admin;

  return (
    <>
      <div
        className={`fixed top-0 left-0 h-full w-[220px] bg-white border-r border-border_color pt-5 pb-2  z-50 transform transition-transform duration-300
      ${isOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
      >
        <div className="relative w-full h-full flex flex-col items-center">
          {/* Close btn */}
          <div className="px-2 flex items-center justify-end md:hidden w-full">
            <button onClick={() => setOpenMenu(false)}>
              <FiX size={24} />
            </button>
          </div>

          {/* Logo */}
          <div className="flex items-center justify-center">
            <div className="w-16 h-16">
              <img
                src={logo}
                alt="Loading"
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          {/* Navigation Part */}
          <div className="pt-4  w-full flex items-center justify-center">
            <ul className="flex flex-col">
              {menuItems.map((item) => (
                <li key={item.path} className="relative mb-[6px]">
                  <NavLink
                    to={item.path}
                    end={
                      item.path === "/user" ||
                      item.path === "/artist" ||
                      item.path === "/admin"
                    }
                    className={({ isActive }) =>
                      `px-[24px] py-3 flex items-center justify-start gap-2 outline-none  rounded-[10px]  ${
                        isActive
                          ? "text-white font-bold bg-primary"
                          : "text-black hover:bg-primary hover:text-white"
                      }`
                    }
                  >
                    {({ isActive }) => (
                      <>
                        {isActive && (
                          <span className="absolute -left-3 top-1/2 transform -translate-y-1/2 h-5 w-[3px] bg-primary rounded-r-md"></span>
                        )}
                        <img src={item.icon} alt="icon" className="w-5 h-5" />
                        <span className="font-medium text-xs font-grotesk tracking-wider">
                          {item.label}
                        </span>
                      </>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          onClick={() => setOpenMenu(false)}
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
        ></div>
      )}
    </>
  );
};
